export enum ApiTechnology {
  CSP_PTC = 1,
  PV = 2,
}